const aColorPicker = {
  aColorPicker: {
    label: 'Selecciona un color para tu Academia...',

    validation: {
      colorPicked: {
        numHexadecimal: 'Número hexadecimal incorrecto (#FFFFFF).',
        maxLength: 'La longitud permitida es de 6 caracteres.',
        minLength: 'La longitud permitida es de 6 caracteres.'
      }
    }
  }
}

export default aColorPicker
